import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";

import Home from "./pages/ Home";
import TrackOrder from "./pages/ TrackOrder";
import About from "./pages/About";
import Header from "./Component/ Header";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function App() {
  return (
    <>
      <Router>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/about" element={<About />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
